// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 20px;
}

.close-btn {
  border: none !important;
  background: none !important;
  outline: none !important;
  box-shadow: none !important;
  padding: 0 !important;
  cursor: pointer;
}

.close-btn:focus {
  outline: none !important;
}

.upload-box {
  border: 1px dashed #d9d9d9;
  border-radius: 12px;
  padding: 32px 20px;
  background: #fafafa;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  gap: 0;
  flex-wrap: wrap;
}

.upload-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  min-width: 180px;
  padding: 8px 16px;
}

.upload-col-divider {
  width: 1px;
  background-color: #e0e0e0;
  align-self: stretch;
  margin: 0 8px;
}

.btn {
  background: linear-gradient(90deg, #ed845d 0%, #da522f 100%);
  border-radius: 24px;
  margin-bottom: 12px;
  color: #ffffff;
}

.file-info {
  font-size: 13px;
  color: #888;
  margin-top: 8px;
}

.file-name {
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
}

.instruction-body {
  font-size: 14px;
}

.fields-grid {
  display: flex;
  gap: 60px;
  margin-top: 10px;
}

.sample-link {
  color: #1a40c7 !important;
  cursor: pointer;
  text-decoration: underline;
}


/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/careplus/upload-employees-dialog/upload-employees-dialog.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,2BAA2B;EAC3B,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,MAAM;EACN,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,OAAO;EACP,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,4DAA4D;EAC5D,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,0BAA0B;AAC5B;;;AAGA,glGAAglG","sourcesContent":[".dialog-header {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.close-btn {\n  border: none !important;\n  background: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n  padding: 0 !important;\n  cursor: pointer;\n}\n\n.close-btn:focus {\n  outline: none !important;\n}\n\n.upload-box {\n  border: 1px dashed #d9d9d9;\n  border-radius: 12px;\n  padding: 32px 20px;\n  background: #fafafa;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 0;\n  flex-wrap: wrap;\n}\n\n.upload-column {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n  min-width: 180px;\n  padding: 8px 16px;\n}\n\n.upload-col-divider {\n  width: 1px;\n  background-color: #e0e0e0;\n  align-self: stretch;\n  margin: 0 8px;\n}\n\n.btn {\n  background: linear-gradient(90deg, #ed845d 0%, #da522f 100%);\n  border-radius: 24px;\n  margin-bottom: 12px;\n  color: #ffffff;\n}\n\n.file-info {\n  font-size: 13px;\n  color: #888;\n  margin-top: 8px;\n}\n\n.file-name {\n  font-weight: 500;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 6px;\n}\n\n.instruction-body {\n  font-size: 14px;\n}\n\n.fields-grid {\n  display: flex;\n  gap: 60px;\n  margin-top: 10px;\n}\n\n.sample-link {\n  color: #1a40c7 !important;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
